import { computed } from 'mobx'
import { schema, MARKER_FORMAT } from 'prose-core'
import { useContext } from 'react'

import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { ButtonHook } from 'common/Prose/Toolbar/Types'
import { turnIntoList } from 'common/Prose/utils'
import { AlmanacEditorStateContext } from 'stores/EditorState'

export function useBulletListMarkerToggle(marker: MARKER_FORMAT): ButtonHook {
  const editorView = useEditorView()
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacState = useContext(AlmanacEditorStateContext)!

  const active = computed(() => almanacState.activeUlMarkerFormats.has(marker)).get()

  const handleClick = turnIntoList(editorView, schema.nodes.unordered_list, { markerFormat: marker })

  return { active, handleClick }
}
